import React, { useState } from 'react';
import { GiftIcon, MailIcon, StarIcon, CheckCircle2Icon } from 'lucide-react';
export function CustomerCareClub() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail('');
    }, 1000);
  };
  return <section className="section-padding bg-white relative overflow-hidden" data-id="element-17">
      {/* Subtle paw print decoration */}
      <div className="absolute top-10 right-10 w-48 h-48 opacity-5 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8QwuRvfxBY7HY1xAguEFR2/Picturea11.png)',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-18"></div>

      <div className="container-wide max-w-5xl relative z-10" data-id="element-19">
        <div className="bg-brand-blue-50 rounded-3xl p-8 md:p-10 shadow-sm border border-brand-blue-100 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-20">
          {/* Content Side */}
          <div className="flex-1" data-id="element-21">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-brand-blue text-sm font-bold mb-5 shadow-sm border border-brand-blue-100" data-id="element-22">
              <GiftIcon className="w-4 h-4" data-id="element-23" />
              15,000+ Members Already Saving
            </div>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4 leading-tight" data-id="element-24">
              Join the Care Club
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-25">
              Get $10 off your first premium pet food order, plus earn reward
              points on every purchase. Free to join!
            </p>

            <ul className="space-y-3 mb-6" data-id="element-26">
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-27">
                <CheckCircle2Icon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-28" />
                $10 Reward at 200 Points
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-29">
                <CheckCircle2Icon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-30" />
                Members-Only Specials
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-31">
                <CheckCircle2Icon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-32" />
                No card needed — just use your phone number
              </li>
            </ul>
          </div>

          {/* Form Side */}
          <div className="w-full md:w-[400px] bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-33">
            <h3 className="font-heading font-bold text-lg text-gray-900 mb-4 text-center" data-id="element-34">
              Claim your $10 welcome voucher
            </h3>

            {isSuccess ? <div className="bg-brand-green-50 border border-brand-green-200 rounded-xl p-4 flex items-center gap-3 text-brand-green-800" data-id="element-35">
                <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-36">
                  <StarIcon className="w-4 h-4 text-white fill-current" data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <div className="font-bold" data-id="element-39">Welcome to the club!</div>
                  <div className="text-sm" data-id="element-40">
                    Check your email for your $10 voucher.
                  </div>
                </div>
              </div> : <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-id="element-41">
                <div className="relative" data-id="element-42">
                  <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl py-3.5 pl-11 pr-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-brand-blue focus:bg-white transition-all" data-id="element-43" />
                  <MailIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-44" />
                </div>
                <button type="submit" disabled={isSubmitting} className="btn-primary py-3.5 w-full shadow-blue-glow disabled:opacity-70 active:scale-95" data-id="element-45">
                  {isSubmitting ? 'Joining...' : 'Join Free'}
                </button>
                <p className="text-xs text-gray-400 text-center mt-2" data-id="element-46">
                  We respect your privacy and never share your details.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}